import React, { FC } from 'react';
import styles from './home_logos.module.scss';

type Props = {
  logos: Array<{
    logo: {
      url: string;
    };
  }>;
};

export const HomeLogos: FC<Props> = ({ logos }) => (
  <div className={styles.container}>
    {logos.map(item => (
      <div key={item.logo.url} className={styles.imageContainer}>
        <img className={styles.imageItem} src={item.logo.url} />
      </div>
    ))}
  </div>
);
